fx.translations("es", {
    // action bar
    
    
    // board
    "Ajouter 2 pages" : "Añadir 2 páginas",
    "Supprimer 2 pages" : "Eliminar 2 páginas",
    "Votre album ne peut contenir moins de $ pages" : "Su álbum no puede contener menos de $ páginas",
    "Copier" : "Copiar", 
    "Couper" : "Cortar",
    
    // panels
    "Nombre de photos par page" : "Número de fotos por página",
    
    

    // photoimport
    "Tout sélectionner" : "Seleccionar todo",
    "Tout déselectionner" : "Deseleccionar todo",
   
    
    "Si rien ne ne se passe après avoir cliqué sur le bouton de connexion, cela signifie que votre navigateur bloque les popups. Il vous suffit d'autoriser votre navigateur à afficher les popups pour résoudre le problème." : "Si no ocurre nada después de hacer clic en el botón de inicio de sesión, significa que tu navegador está bloqueando las ventanas emergentes. Simplemente debes permitir que tu navegador muestre ventanas emergentes para resolver el problema",
    "Nous avons bientôt fini de récupérer vos photos" : "Pronto recuperaremos sus fotos",
    "On s’occupe de vous rediriger quand c’est terminé" : "Le redirigiremos cuando haya terminado",
   
    // popups
    
    
    "Cliquez pour aller à la page" : "Pincha aquí para ir a la página",
    
    "Souhaitez-vous commander votre ouvrage dans l'état ?" : "¿Quieres encargar tu libro tal cual está?",
  
    "La couverture a été changée" : "Se ha cambiado la cubierta",
    "Vérifier que tout est placé correctement sur votre couverture." : "Compruebe que todo está colocado correctamente en tu cubierta",
    
    "Ce changement de couverture n'est pas possible" : "Este cambio de cubierta no es posible",
    "mais avec cette couverture votre album ne peut contenir <strong>plus de $ pages</strong>.<br><br> Veuillez supprimer des pages avant de choisir cette couverture." : "pero con esta portada tu álbum no puede contener mas que <strong>$ paginás</strong>. Borre las páginas antes de elegir esta portada.",
    "mais avec cette couverture votre album doit contenir <strong>au moins $ pages</strong>.<br><br> Veuillez ajouter des pages avant de choisir cette couverture." : "pero con esta portada tu álbum debe contener al menos <strong>than $ paginás</strong>. Añada páginas antes de elegir esta cubierta.",
    "J'ajoutes vos photos dans votre gallerie" : "Añado tus fotos a tu galería",
    "Souhaitez-vous que je crée votre album photo ?" : "¿Quieres que cree tu álbum de fotos?",
    "Vos photos seront placées par ordre chronologique,<br>et vous n'aurez plus qu'à vérifier votre album." : "Tus fotos se colocarán en orden cronológico<br>y solo deberás validar tu álbum.",
    "Attention : votre contenu sera totalement remplacé." : "Atención: tu contenido será sustituido por completo",
    "Oui, Créez mon album" : "Sí, crea mi álbum",
    "Non, merci" : "No, gracias",
    "Un instant, je place vos photos..." : "Un momento, voy a colocar tus fotos...",
    "Cet aperçu vous montre comment sera votre album une fois imprimé.<br/>Assurez-vous de n'avoir rien oublié avant de commander." : "Esta vista previa te muestra el aspecto que tendrá tu álbum una vez impreso.<br/>Asegúrate de que no has olvidado nada antes de hacer el encargo.",
    "J'ai préparé l'aperçu de votre album" : "He preparado la vista previa de tu álbum",
    "Voir l'aperçu" : "Ver la vista previa",
    
    "Continuer" : "Seguir",

    // screens
    "Copie en cours" : "Copia en curso",
    "Ca va être rapide !" : "¡Va a ser rápido!",
   
    "Choisissez la couverture de votre album" : "Elige la portada de tu álbum",
    "Quel type d'ouverture souhaitez-vous ?" : "¿Qué tipo de apertura desea?",
   
    
    "Choisissez la forme de votre album" : "Escoge el formato de tu álbum",
   
    "Grille activée" : "Rejilla habilitada",
    "Grille désactivée" : "Rejilla desactivada",
    "La grille de repère est maintenant activée" : "La cuadrícula de guía ahora está activada",
    "La grille de repère est maintenant désactivée" : "La cuadrícula de guía ahora está desactivada",

    "Les photos ont bien été téléchargées depuis votre mobile" : "Las fotos se han descargado correctamente desde su móvil",
    "Téléchargement des photos mobile terminé !" : "¡Descarga de fotos móviles completada!",

    "Epaisseur" : "Espesor",

    // zoom
    "Vue Globale" : "Visión global",
    "Vue Edition" : "Vista Edición",

    // New
    "Editer" : "Editar",
    "Prévisualiser" : "Vista previa",

    
     
     
     
     "Aller directement à l'éditeur" : "Ir directamente al editor",
     "Suivant" : "Siguiente",
     
     "Sélectionner les meilleures !" : "¡Escoge los mejores!",
     "Tout sélectionner" : "Seleccionar todo",
     "J'ai sélectionné vos photos" : "He seleccionado tus fotos",
     "Vous pouvez modifier ma sélection avant de lancer la création intelligente de votre album" : "Puedes modificar mi selección antes de iniciar la creación inteligente de tu álbum",
     "Créer votre album !" : "¡Cree tu álbum!",
     
     
     
     "Votre fichier a été importé" : "Tu archivo ha sido importado",
     "Il a été ajouté à vos photos" : "Se ha añadido a tus fotos",
 
     
     
     "Options" : "Opciones",
 
     "+ $ €" : "+ $ €",
 
     //----
     "Couvertures" : "Cubiertas",
     "Thèmes" : "Temas",
     
     "Mises en page" : "Diseños",
     
     "Vue Simple" : "Vista sencilla",     
     "Sauvegarder en tant que Modèle" : "Guardar este diseño",


     "Numéroter les pages" : "Numerar las páginas",
     "Supprimer la numérotation" : "Eliminar la numeración",
     
     "J'ai numéroté vos pages" : "He numerado sus páginas",
     "Cliquez pour éditer la taille, la police et la couleur" : "Haz clic para editar el tamaño, la fuente y el color",
     "Ok" : "Ok",


     "Changer de modèle" : "Cambiar de diseño",

     "Choisissez la couverture de votre album" : "Elige la portada de tu álbum",

     "Thématique" : "Recomendado",
     "Classique" : "Clásico",
     "Sauvegardé" : "Personal",

     "Nombre de photos" : "Número de fotos",

     "Placer vos photos automatiquement" : "Colocar tus fotos automáticamente",
     "Mises en pages" : "Diseños",
});

